import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import styles from './CustomCard.module.scss';
import { useVoucherContext } from '../../context';
import { CustomCardProps } from './types';
import BlackGiftCard from 'assets/svg/BlackGiftCard.svg';

import { MultiVoucherFormSchema } from '../../form/schema';

const CustomCard: React.FC<CustomCardProps> = ({ index }) => {
  const { state } = useVoucherContext();
  const { customGiftCards } = state;

  if (!customGiftCards || customGiftCards.length === 0) {
    return <BlackGiftCard />;
  }

  const { setValue, watch, getValues } =
    useFormContext<MultiVoucherFormSchema>();

  const fieldName = `vouchers.${index}.custom_gift_card_id` as const;
  const selectedCardId =
    watch(fieldName) ?? getValues(fieldName) ?? customGiftCards[0]?.id;

  useEffect(() => {
    if (!getValues(fieldName)) {
      setValue(fieldName, customGiftCards[0]?.id);
    }
  }, [fieldName, getValues, setValue, customGiftCards]);

  const handleSelectCard = (id: number) => {
    setValue(fieldName, id);
  };

  const selectedCard = customGiftCards.find(card => card.id === selectedCardId);

  return (
    <div className={styles.container}>
      {selectedCard && selectedCard.image_url && (
        <div className={styles.selected} key={selectedCard.id}>
          <img src={selectedCard.image_url} alt={selectedCard.name} />
        </div>
      )}
      <div className={styles.cta}>Choose a design</div>
      <div className={styles.thumbs}>
        {customGiftCards.map(
          giftCard =>
            giftCard.image_url && (
              <div
                key={giftCard.id}
                className={styles.thumbnail}
                onClick={() => handleSelectCard(giftCard.id)}
              >
                <img src={giftCard.image_url} alt={giftCard.name} />
              </div>
            )
        )}
      </div>
    </div>
  );
};

export default CustomCard;
